import React from 'react';

import SuggestionTable from './SuggestionTable';

export default () => <SuggestionTable />;
